
import TokenContract from './getAbis/token.json'
import Web3EthContract from "web3-eth-contract";
import { providerURL } from './walletConnect/utils';


export const getUsdPrice = async () => {
    const { ethereum } = window;
    let provider = providerURL()
    Web3EthContract.setProvider(provider);
    const contract_token = new Web3EthContract(TokenContract.abi, TokenContract.TOKEN_ADDRESS);

    let perUsdToken = parseFloat(await contract_token.methods.getQuotes('1000000000000000000').call() / 10 ** 6).toFixed(10);
    console.log("init price here ", (perUsdToken))
    // if (parseFloat(perUsdToken) < 0.0001) {
    //     return 0;
    // }
    // let finalPrice = 1 / perUsdToken
    // console.log("1 / perUsdToken ", 1 / perUsdToken)
    return (perUsdToken);
}